import { Component, computed, effect, inject, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Deal, SalesApsService } from '@zayan-erp/sales';
import { SignStatusBadgeComponent } from '@zayan-erp/shared';
import { rxResourceFixed } from '@zayan-erp/shared';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-deal-sidebar',
  standalone: true,
  imports: [CommonModule, SignStatusBadgeComponent],
  templateUrl: './deal-sidebar.component.html',
  styleUrls: ['./deal-sidebar.component.scss']
})
export class DealSidebarComponent {
  prospectId = input.required<string>();
  selectedDealId = input.required<string>();
  // onDealSelect = output<string>();
  showHideDeal = output<void>();
  #router = inject(Router);

  #salesApsService = inject(SalesApsService);

  selectDeal(dealId: string) {
    this.#router.navigate(['/sales/aps/', dealId, 'overview']);
    // this.onDealSelect.emit(dealId);
  }

  showHideDeals() {
    this.showHideDeal.emit();
  }
  constructor() {
    effect(() => {
      this.#salesApsService.realoadDeal$.subscribe(value => {
        if (value === null) {
          this.prospectDealsResource.reload();
        }
      });
    });
  }
  prospectDealsResource = rxResourceFixed({
    params: () => ({ prospectId: this.prospectId() }),
    stream: ({ params }): Observable<Deal[]> => {
      if (params.prospectId) {
        return this.#salesApsService.getDealsByProspectId(params.prospectId, false);
      }
      return of([]);
    }
  });

  prospectDeals = computed(() => this.prospectDealsResource.value() ?? []);
}
